export default class DtoUser{

	constructor(obj) {
		this.login = obj.login
		this.firstName = obj.firstName
		this.lastName = obj.lastName
		this.email = obj.email
		this.mobileNumber = obj.mobileNumber
		this.fixNumber = obj.fixNumber
		this.address = obj.address
		this.city = obj.city
		this.administrator = obj.administrator
		this.administratorUser = obj.administratorUser
        this.firstConnection = obj.firstConnection === null ? true : obj.firstConnection
		this.latitude = obj.latitude ? obj.latitude.toString() : undefined
		this.longitude = obj.longitude ? obj.longitude.toString() : undefined
		this.zoom = obj.zoom ? obj.zoom.toString() : undefined
	}
}



// WEBPACK FOOTER //
// ./src/home/dto/DtoUser.js